import React from 'react';
import { StepProps } from '../types';

const StepSituation: React.FC<StepProps> = ({ state, onUpdate, onNext, isActive }) => {
  const maxLength = 300;
  const currentLength = state.situation.length;
  const isValid = currentLength >= 10;

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value;
    if (value.length <= maxLength) {
      onUpdate({ situation: value });
    }
  };

  return (
    <>
      <h2 className="step-title">What are you trying to decide?</h2>
      <textarea
        value={state.situation}
        onChange={handleChange}
        placeholder="Describe your situation..."
        rows={4}
        disabled={!isActive}
      />
      <div className="char-counter">
        {currentLength}/{maxLength}
      </div>
      {isActive && (
        <button
          className="btn"
          onClick={onNext}
          disabled={!isValid}
        >
          Next
        </button>
      )}
    </>
  );
};

export default StepSituation;
